module.exports = __webpack_public_path__ + "static/media/Objet_solutions.0376570d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_bg/Objet_solutions.png
// module id = 2285
// module chunks = 0